import React from 'react'
import { Avatar } from 'antd'

import { PlatformUserDomainRecord } from '../../../../models/domain/platform-user-domain-record'
import { FeatureAnticon } from '../../../icons/feature-icon'

/**
 * Module-level cache of icon URLs that failed to load.
 * Persists across remounts so icons don't flicker when
 * RowComponent is recreated by react-window.
 */
const failedUrls = new Set<string>()

/**
 * DomainIcon - Domain icon component with fallback handling
 *
 * Displays domain icon using Ant Design Avatar component with automatic
 * fallback to the Domain icon when:
 * - defaultIconUrl is null or undefined
 * - Image fails to load (tracked in module-level cache to survive remounts)
 */
const DomainIcon: React.FC<{ domain: PlatformUserDomainRecord | null | undefined }> = React.memo(({ domain }) => {
    const url = domain?.defaultIconUrl
    const altText = domain?.displayName ? `${domain.displayName} logo` : 'Domain logo'

    if (!url || failedUrls.has(url)) {
        return <Avatar icon={<FeatureAnticon slot="rail:domain:settings" aria-hidden="true" />} gap={2} alt={altText} />
    }

    return (
        <Avatar
            src={url}
            alt={altText}
            onError={() => {
                failedUrls.add(url)
                return true
            }}
        />
    )
})

export default DomainIcon
